export default __webpack_public_path__ + "images/b020659ef00745a770244fe5ed5fa449-rafting.webp";